import { ProjectFileService as OvermapProjectFileService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProjectFileService extends OvermapProjectFileService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
